"use strict";

var novicell = novicell || {};

novicell.cookieListFormatting =
    novicell.cookieListFormatting ||
    new (function() {
        var cookieScriptUrl = "";
        this.init = function() {
            var scriptHolderTag = document.getElementById(
                "js-cookie-declaration"
            );
            if (!scriptHolderTag) {
                return;
            }
            cookieScriptUrl = scriptHolderTag.getAttribute("data-src");
            const self = this;
            const tag = document.createElement("script");
            tag.onload = function loadAndAddHeadersForMobile() {
                setTimeout(() => {
                    self.addHeaderAttributes();
                }, 150);
            };
            tag.src = cookieScriptUrl;

            scriptHolderTag.appendChild(tag);
        };

        this.addHeaderAttributes = function() {
            const tableElements = document.getElementsByClassName(
                "CookieDeclarationTable"
            );
            for (let a = 0; a < tableElements.length; a += 1) {
                const headers = [];
                const headerElements = tableElements[a].getElementsByClassName(
                    "CookieDeclarationTableHeader"
                );
                for (let i = 0; i < headerElements.length; i += 1) {
                    headers[i] = headerElements[i].textContent;
                }

                const rowElements = tableElements[a].querySelectorAll(
                    "tbody tr"
                );
                for (let b = 0; b < rowElements.length; b += 1) {
                    const row = rowElements[b];
                    const cells = row.getElementsByClassName(
                        "CookieDeclarationTableCell"
                    );
                    for (let c = 0; c < cells.length; c += 1) {
                        cells[c].setAttribute("data-mobile-header", headers[c]);
                    }
                }
            }
        };
    })();
